<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <div class="d-flex flex-row justify-content-between align-items-center mb-4">
      <h1 v-if="selectedOption === OPT_TRAMITES">{{ $t("tramiteEnergia.titulo") }}</h1>
      <h1 v-if="selectedOption === OPT_OPERACIONES">{{ $t("operacionEnergia.titulo") }}</h1>
      <RadioButtonGroup v-model="selectedOption" :options="radioOptions" name="operaciones" />
    </div>
    <div v-if="selectedOption === OPT_OPERACIONES">
      <operaciones-energia-grid @operationSelected="onOperationSelected" @refreshGridTramites="onRefreshGridTramites"/>
      <tramites-energia-operacion-grid ref="gridTramites" :idOperacion="selectedIdOperacion" class="mt-4" />
    </div>
    <div v-if="selectedOption === OPT_TRAMITES">
      <tramites-energia-grid />
    </div>
    
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import OperacionesEnergiaGrid from "@/components/operaciones-energia/OperacionesEnergiaGrid.vue";
import TramitesEnergiaOperacionGrid from "@/components/tramites-energia/TramitesEnergiaOperacionGrid.vue";
import TramitesEnergiaGrid from "@/components/tramites-energia/TramitesEnergiaGrid.vue";
import RadioButtonGroup from "@components/RadioButtonGroup.vue";
import { useIntl } from "@/.shared/services/i18n/i18nservice";

const router = useRouter();

const props = defineProps({
  mode: {
    type: String as () => 'TRAMITES' | 'OPERACIONES',
    required: false,
    default: 'TRAMITES',
  },
});

const OPT_TRAMITES = 'op1';
const OPT_OPERACIONES = 'op2';

const intl = useIntl();

const selectedIdOperacion = ref<string | undefined>(undefined);
const gridTramites = ref<InstanceType<typeof TramitesEnergiaOperacionGrid>>();

const radioOptions = [
  { label: intl.i18n.t('operaciones.ui.rbTramites'), value: OPT_TRAMITES },
  { label: intl.i18n.t('operaciones.ui.rbOperaciones'), value: OPT_OPERACIONES },
];

const selectedOption = ref(props.mode === 'TRAMITES' ? OPT_TRAMITES : OPT_OPERACIONES);

function onOperationSelected(idOperacion: string | undefined) {
  selectedIdOperacion.value = idOperacion;
}

function onRefreshGridTramites() {
  gridTramites.value?.refreshGrid();
}

watch(selectedOption, (newOption) => {
  if (newOption === OPT_OPERACIONES) {
    selectedIdOperacion.value = undefined;
  }
  const mode = newOption === OPT_TRAMITES ? "TRAMITES" : "OPERACIONES";
  router.replace({ name: "operaciones-energia", query: { mode } });
});
</script>